/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateStrategySkillsRequestSkillsInner
 */
export interface UpdateStrategySkillsRequestSkillsInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateStrategySkillsRequestSkillsInner
     */
    idOrName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStrategySkillsRequestSkillsInner
     */
    type: UpdateStrategySkillsRequestSkillsInnerTypeEnum;
}


/**
 * @export
 */
export const UpdateStrategySkillsRequestSkillsInnerTypeEnum = {
    Functional: 'FUNCTIONAL',
    Global: 'GLOBAL'
} as const;
export type UpdateStrategySkillsRequestSkillsInnerTypeEnum = typeof UpdateStrategySkillsRequestSkillsInnerTypeEnum[keyof typeof UpdateStrategySkillsRequestSkillsInnerTypeEnum];


/**
 * Check if a given object implements the UpdateStrategySkillsRequestSkillsInner interface.
 */
export function instanceOfUpdateStrategySkillsRequestSkillsInner(value: object): value is UpdateStrategySkillsRequestSkillsInner {
    if (!('idOrName' in value) || value['idOrName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateStrategySkillsRequestSkillsInnerFromJSON(json: any): UpdateStrategySkillsRequestSkillsInner {
    return UpdateStrategySkillsRequestSkillsInnerFromJSONTyped(json, false);
}

export function UpdateStrategySkillsRequestSkillsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStrategySkillsRequestSkillsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'idOrName': json['idOrName'],
        'type': json['type'],
    };
}

export function UpdateStrategySkillsRequestSkillsInnerToJSON(value?: UpdateStrategySkillsRequestSkillsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'idOrName': value['idOrName'],
        'type': value['type'],
    };
}

